import { Globals } from "./Globals";
import { QRFC } from "./QRFC";

class QSharedFilterRFCBase extends QRFC {
  constructor() {
    super();
    this.fWSMgr = null;
  }

  InitSharedFilterRFC(wsMgr) {
    this.fWSMgr = wsMgr;
    this.InitRemoteCall(this, "POST", true, false);
    this.SetAllowStacked(true);
  }

  SetParams(orgName, userName, mode, data) {
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
    if (data) {
      this.AddParameter("data", typeof data === "string" ? data : JSON.stringify(data));
    }
  }

  GetCallName() {
    return "qsharedfilters";
  }

  DoTransactionComplete(response, callBackObj) {
    // no-op; callers use the promise
  }
}

export const QSharedFilterRFC = {
  ShareFilter(wsMgr, data) {
    const rfc = new QSharedFilterRFCBase();
    rfc.InitSharedFilterRFC(wsMgr);
    rfc.SetParams(wsMgr.GetAccountName(), wsMgr.GetUserName(), "shareFilter", data);
    const promise = rfc.GetPromise();
    Globals._rfcMgr.QueueRFC(rfc);
    return promise;
  },

  GetSharedFilters(wsMgr, chartId, type, groupIds) {
    const rfc = new QSharedFilterRFCBase();
    rfc.InitSharedFilterRFC(wsMgr);
    const data = { chartId };
    if (type) data.type = type;
    if (groupIds) data.userGroups = groupIds;
    rfc.SetParams(wsMgr.GetAccountName(), wsMgr.GetUserName(), "getSharedFilters", data);
    const promise = rfc.GetPromise();
    Globals._rfcMgr.QueueRFC(rfc);
    return promise;
  },

  UpdateShareAccess(wsMgr, filterId, sharedWith) {
    const rfc = new QSharedFilterRFCBase();
    rfc.InitSharedFilterRFC(wsMgr);
    const data = { filterId, sharedWith };
    rfc.SetParams(wsMgr.GetAccountName(), wsMgr.GetUserName(), "updateShareAccess", data);
    const promise = rfc.GetPromise();
    Globals._rfcMgr.QueueRFC(rfc);
    return promise;
  },

  UpdateSharedFilter(wsMgr, filterId, definition) {
    const rfc = new QSharedFilterRFCBase();
    rfc.InitSharedFilterRFC(wsMgr);
    const data = { filterId, definition };
    rfc.SetParams(wsMgr.GetAccountName(), wsMgr.GetUserName(), "updateSharedFilter", data);
    const promise = rfc.GetPromise();
    Globals._rfcMgr.QueueRFC(rfc);
    return promise;
  },

  DeleteSharedFilter(wsMgr, filterId) {
    const rfc = new QSharedFilterRFCBase();
    rfc.InitSharedFilterRFC(wsMgr);
    const data = { filterId };
    rfc.SetParams(wsMgr.GetAccountName(), wsMgr.GetUserName(), "deleteSharedFilter", data);
    const promise = rfc.GetPromise();
    Globals._rfcMgr.QueueRFC(rfc);
    return promise;
  }
};
